(($) => {
  $(document).ready(() => {
    $('.scroll-to-element').click(function(e) {
      e.preventDefault()

      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top -150
      }, 1500);
    })
  })
})(jQuery)
